import { useColorModeValue } from "@chakra-ui/react";

export const useFormTheme = () => {
  const bg = useColorModeValue("white", "#252E3F"); // Card background
  const pageBg = useColorModeValue("white", "gray.800"); // Page background
  const textColor = useColorModeValue("gray.600", "gray.200"); // Main text
  const linkColor = useColorModeValue("primary.500", "primary.300"); // Links
  const errorColor = useColorModeValue("red.500", "red.300"); // Form errors
  const darkGradient = "linear(to-t, rgba(0, 20, 60, 0.95) 0%, #1A1D21 40%)";
  const lightGradient = {
    base: "linear(to-t, rgba(0, 64, 255, 0.44) 0.2%, white 10%)",
    lg: "linear(to-t, rgba(0, 64, 255, 0.44) 0.5%, white 30%)",
  };

  return {
    bg,
    pageBg,
    textColor,
    linkColor,
    errorColor,
    darkGradient,
    lightGradient,
  };
};
